import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { NotifyError } from 'src/app/pages/pages.actions';
import { PagesState } from 'src/app/pages/pages.model';
import { callerEmail, callerFirstName, callerLastName } from 'src/app/pages/pages.selectors';
import { ObjectId } from 'src/app/utils';

import { KeyziiService } from 'src/app/wss/keyzii.service';
import { WSSState } from 'src/app/wss/wss.model';
import { callerId, callId, } from 'src/app/wss/wss.selectors';
import { AddPatient, AddUser, SetPatientName } from '../training.actions';
import { TrainingState } from '../training.model';
import { TrainingService } from '../training.service';

@Component({
  selector: 'patient',
  templateUrl: './patient.component.html',
  styleUrls: ['../new-user/new-user.component.scss', './patient.component.scss']
})
export class PatientComponent {
  @Output() close: EventEmitter<any> = new EventEmitter();
  bReady: boolean = false
  bNewPatient: boolean = true

  btn_lbl = "Add Patient"

  first_name: string = ""
  last_name: string = ""

  title: string = "New Patient"

  _patient: any

  caller_email: string | undefined
  caller_first_name: string | undefined
  caller_last_name: string | undefined
  caller_id: string | undefined
  @Input() set patient(p: any) {
    if (p) {
      this._patient = p
      this.btn_lbl = "Save"
      this.title = "Add Patient"
      if (p.first_name) {
        this.first_name = p.first_name
        this.title = "Edit Patient"
        this.bNewPatient = false
      }
      if (p.last_name) {
        this.last_name = p.last_name
        this.title = "Edit Patient"
        this.bNewPatient = false
      }
      //Now select the options for the filet
    }

  }
  subscriptions: any[] = []
  call_id: string | undefined

  constructor(
    public keyzii_service: KeyziiService,
    public pagesState: Store<PagesState>,
    public trainingStore: Store<TrainingState>,
    public training_sevice: TrainingService,
    public training_service: TrainingService,
    private wssState: Store<WSSState>,
  ) {

    console.log("add training user")


    this.subscriptions.push(this.wssState.select(callId).subscribe((call_id: string | undefined) => {
      this.call_id = call_id
    }))
    this.subscriptions.push(this.pagesState.select(callerEmail).subscribe((email: string) => {
      this.caller_email = email
    }))
    this.pagesState.select(callerFirstName).subscribe((name: string | undefined) => {
      this.caller_first_name = name
    })
    this.pagesState.select(callerLastName).subscribe((name: string | undefined) => {
      this.caller_last_name = name
    })
    this.subscriptions.push(this.wssState.select(callerId).subscribe(async (id: string | undefined) => {
      this.caller_id = id
    }))

  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
  }
  async save() {
    if (!this.bReady) {
      this.pagesState.dispatch(new NotifyError("Add First and last name"))
      return
    }
    if (this.bNewPatient) {
      let patient_id = ObjectId()
      this.trainingStore.dispatch(new AddPatient(patient_id, this.first_name, this.last_name))
      //if we are in a call also addd the user
      if (this.caller_email && this.caller_id) {
        setTimeout(async () => {
          let user: any = {
            email: this.caller_email,
            first_name: this.caller_first_name,
            last_name: this.caller_last_name,
            roll: "parent",
            patient_first_name: this.first_name,
            patient_last_name: this.last_name,
            patient_id: patient_id,
            _id: this.caller_id
          }
          try {
            let new_user = await this.training_sevice.addUser(user)
            this.trainingStore.dispatch(new AddUser(new_user))
            //We need to make sure that the user now has the new patient in the list

          } catch (e: any) {
            console.error(e)
          }

        })
      }

    } else {
      this.trainingStore.dispatch(new SetPatientName(this.first_name, this.last_name))
    }
    this.close.emit()
  }


  cancel() {
    this.close.emit()
  }

  checkReady() {
    this.bReady = (this.first_name.length > 0 && this.last_name.length > 0)
  }
  async deletePatient() {
    try {
      await this.training_service.deletePatient(this._patient)
      this.close.emit()
    } catch (e) {
      console.error(e)
    }
  }
}
